import { footerLinkData } from '../../config/footer';
import React from 'react';
import FooterButton from './FooterButton';

const Footer = () => {
  return (
    <div className="flex flex-row min-h-0 mt-auto justify-evenly text-xs/snug bottom-0">
      <div className="hidden md:flex ">
        {footerLinkData.map((data, index) => (
          <div key={index} className="flex shrink max-w-64 px-4 py-1 text-wrap font-medium">
            <FooterButton data={data} key={index} />
          </div>
        ))}
      </div>
      <div className="text-black dark:text-soft-blue-grey text-wrap px-4 py-2 text-xs/snug font-normal">Copyright © 2026 Domino Data Lab. All rights reserved.</div>
    </div>
  );
};
export default Footer;
